
const mutations = {
  setLk(state, { events, tours, sale }) {
    state.events = events
    state.tours = tours
    state.sale = sale
      ? {
        ...state.sale,
        ...sale
      }
      : null
  },
  setErrorsStatus(state, payload) {
    state.hasErrors = payload
  },
}

export default mutations